import { useBaseMutation } from "../../../../hooks/useBaseMutation";


export const useCreateStoreAccount = () => {
    
    return useBaseMutation(
        'put',
        'https://api.menufy.link/restaurantBackend/stores/payment', // Endpoint
        // 'storeInfo',
        // Data transformation function
    );
};
